import { render, staticRenderFns } from "./TheMenuAdditionalMenu.vue?vue&type=template&id=8db4e5ba&scoped=true&"
import script from "./TheMenuAdditionalMenu.vue?vue&type=script&lang=js&"
export * from "./TheMenuAdditionalMenu.vue?vue&type=script&lang=js&"
import style0 from "./TheMenuAdditionalMenu.vue?vue&type=style&index=0&id=8db4e5ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db4e5ba",
  null
  
)

export default component.exports